import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonGroup,
  Button,
} from 'react-bootstrap';
import { browserHistory } from 'react-router';
import { displayBidderBidState } from '../../../core/api';
import BidDetailPanel from './BidDetailPanel';
import StyledGriddle from '../../../components/StyledGriddle';
import { fullDate } from '../../../core/date';


const sortProperties = [
  { id: 'start', sortAscending: true },
  { id: 'group', sortAscending: true },
  { id: 'name', sortAscending: true },
];


const dateDisplay = ({ value }) => {
  return (
    <span> {fullDate(value)} </span>
  )
}

function findById(value) {
  console.log('findById ', value.id, this);
  return value.id === Number(this);
}
function getUserDisplay(user) {
  if (user) {
    if (user.first_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    return user.username;
  }
  return 'Unassigned';
}

class ProposalTable extends React.Component {
  constructor(props) {
    super(props);
    if (props.detail) {
      this.state = {
        bid: props.detail,
      };
    }
    this.showBid = this.showBid.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.detail !== nextProps.detail) {
      if (nextProps.detail) {
        this.setState({
          bid: nextProps.detail,
        });
      } else {
        this.setState({
          bid: nextProps.detail,
        });
      }
    }
  }
  closeModal() {
    const url = `/booking/${this.props.proposal.id}`;
    browserHistory.push(url);
  }
  showBid(e) {
    e.preventDefault();
    const bid = e.currentTarget.getAttribute('data-item');
    if (bid) {
      const url = `/booking/${this.props.proposal.id}/${bid}`;
      browserHistory.push(url);
    }
  }
  findBid(id) {
    const idx = this.props.proposal.bids.findIndex(findById, id);
    if (idx === -1) {
      console.log('Unable to find bid: ', id);
      return {};
    }
    return this.props.proposal.bids[idx];
  }

  render() {
    const ButtonColumn = ({ value }) => (
      <ButtonGroup>
        <Button bsStyle="info" data-item={value} onClick={this.showBid}>
          <i className="fa fa-pencil fa-lg" />
        </Button>
      </ButtonGroup>
    );

    const convertedBids = [];
    const bids = this.props.proposal.bids;
    if (bids) {
      bids.forEach((bid) => {
        const displayState = displayBidderBidState(bid.buyer_state, bid.bidder_state);
        if (!['Unsent'].includes(displayState)) {
          convertedBids.push({
            id: bid.id,
            name: bid.hotel.name,
            group: bid.bidset.event.group_name,
            location: `${bid.hotel.locality}, ${bid.hotel.region}`,
            start: bid.bidset.event.start,
            end: bid.bidset.event.end,
            bidder: getUserDisplay(bid.bidder),
            state: displayState,
          });
        }
      });
    }

    return (
      <div>
        {this.props.detail && (
          <BidDetailPanel
            bid={this.findBid(this.state.bid)}
            show={this.props.detail}
            onClose={this.closeModal}
            editBid={this.props.editBid}
            addBidNote={this.props.addBidNote}
            sendBid={this.props.sendBid}
            user={this.props.user}
          />
        )}
        {!this.props.detail && (
          <StyledGriddle
            data={convertedBids}
            sortProperties={sortProperties}
          >
            <RowDefinition>
              <ColumnDefinition id="name" title="Hotelss" />
              <ColumnDefinition id="group" title="Group" />
              <ColumnDefinition id="location" title="Location" />
              <ColumnDefinition id="start" title="Check In" customComponent={dateDisplay} />
              <ColumnDefinition id="end" title="Check Out" customComponent={dateDisplay} />
              <ColumnDefinition id="state" title="Status" />
              <ColumnDefinition id="bidder" title="Contact" />
              <ColumnDefinition id="id" title=" " customComponent={ButtonColumn} />
            </RowDefinition>
          </StyledGriddle>
        )}
      </div>
    );
  }
}


ProposalTable.propTypes = {
  proposal: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  detail: PropTypes.string,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
};

ProposalTable.defaultProps = {
  proposal: {
    bids: [],
  },
  detail: null,
};
export default ProposalTable;



// WEBPACK FOOTER //
// src/routes/booking/components/ProposalTable.js